import { IOperationsState } from '../store/operations.types'

/**
 * Returns action/field4 value for procedures/operations.
 *
 * @remarks
 * Because the action/field3 value for the operations procedure is dictated by a
 * boolean value set by an array of toggles (radio group in web parlance), this
 * if statement is used to determine the action/field3 value for NEMSIS code lookup.
 *
 * @param operation Operations state
 * @returns String containing procedure.action value
 */
export const getOperationsAction = (operationsState: IOperationsState): string | null => {
  if (operationsState.jointCommissionTimeOut) {
    return 'Joint Commission Time Out'
  } else if (operationsState.safetyBrief) {
    return 'Safety Brief'
  } else if (operationsState.hearingPrecautions) {
    return 'Hearing Precautions'
  } else if (operationsState.seizurePrecautions) {
    return 'Seizure Precautions'
  } else if (operationsState.patientLoadedCold) {
    return 'Loaded Cold'
  } else if (operationsState.patientLoadedHot) {
    return 'Load Hot'
  } else if (operationsState.patientOffloadCold) {
    return 'Offload Cold'
  } else if (operationsState.patientOffloadHot) {
    return 'Offload Hot'
  } else if (operationsState.patientMonitoring) {
    return 'Patient Monitoring'
  } else if (operationsState.babyPod) {
    return 'BabyPod'
  } else if (operationsState.pediMate) {
    return 'PediMate'
  } else if (operationsState.patientPersonalProtectiveEquipment) {
    return 'Patient Personal Protective Equipment'
  }
  return null
}
